'use strict';

exports.__esModule = true;
exports.ChatRoomView = exports.styles = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Editable = require('../../../../view/Object/Editable');

var _Editable2 = _interopRequireDefault(_Editable);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _ExitToApp = require('material-ui-icons/ExitToApp');

var _ExitToApp2 = _interopRequireDefault(_ExitToApp);

var _GroupAdd = require('material-ui-icons/GroupAdd');

var _GroupAdd2 = _interopRequireDefault(_GroupAdd);

var _Messages = require('./Messages');

var _Messages2 = _interopRequireDefault(_Messages);

var _AddMember = require('./AddMember');

var _AddMember2 = _interopRequireDefault(_AddMember);

var _Public = require('material-ui-icons/Public');

var _Public2 = _interopRequireDefault(_Public);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _App = require('../../../../../App');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import MembersList from "./Members";


var styles = exports.styles = function styles(theme) {
  return {
    root: {
      // border: "1px solid blue",
      height: "100%",
      display: "flex",
      flexDirection: "column"
    },
    membersShortList: {
      alignItems: "start",
      display: "inline-flex",
      "& > *": {
        margin: 2
      }
    },
    chat: {
      height: "100%",
      // border: "1px solid green",
      display: "flex",
      flexDirection: "column"
    },
    messages: {
      overflow: "hidden",
      // border: "1px solid yellow",
      flex: 1
    },
    editor: {// border: "1px solid red",
    }
  };
};

var ChatRoomView = exports.ChatRoomView = function (_EditableView) {
  _inherits(ChatRoomView, _EditableView);

  function ChatRoomView() {
    _classCallCheck(this, ChatRoomView);

    return _possibleConstructorReturn(this, _EditableView.apply(this, arguments));
  }

  ChatRoomView.prototype.canEdit = function canEdit() {
    var _ref = this.getObjectWithMutations() || {},
        id = _ref.id,
        CreatedBy = _ref.CreatedBy;

    var _ref2 = CreatedBy || {},
        createdById = _ref2.id;

    var _ref3 = this.getCurrentUser() || {},
        currentUserId = _ref3.id;

    return !id || currentUserId && currentUserId === createdById ? true : false;
  };

  ChatRoomView.prototype.renderHeader = function renderHeader() {
    var _this2 = this;

    var _context = this.context,
        Grid = _context.Grid,
        UserLink = _context.UserLink,
        currentUser = _context.user;
    var classes = this.props.classes;
    var object = this.getObjectWithMutations();
    var inEditMode = this.isInEditMode();
    var canEdit = this.canEdit();
    var objectId = object.id,
        isPublic = object.isPublic,
        Members = object.Members,
        code = object.code,
        Invitations = object.Invitations,
        CreatedBy = object.CreatedBy;

    var _ref4 = currentUser || {},
        currentUserId = _ref4.id;

    var _ref5 = CreatedBy || {},
        createdById = _ref5.id;

    var publicButton = _react2.default.createElement(_Public2.default, {
      color: isPublic ? "primary" : "disabled"
    });

    if (inEditMode) {
      publicButton = _react2.default.createElement(_IconButton2.default, {
        onClick: function onClick(event) {
          _this2.updateObject({
            isPublic: !isPublic
          });
        }
      }, publicButton);
    }

    var membersList = [];
    var members = []; // Invitations.map(n => n.User.id).concat(Members)

    if (Invitations && Invitations.length) {
      members = members.concat(Invitations.map(function (n) {
        return n.User;
      }));
    }

    if (Members && Members.length) {
      members = members.concat(Members);
    }

    members = members.slice(0, 5);

    if (Members && Members.length) {
      membersList = members.map(function (n) {
        return _react2.default.createElement(Grid, {
          key: n.id,
          item: true
        }, _react2.default.createElement(UserLink, {
          user: n,
          showName: false,
          size: 'small'
        }));
      });
    }

    membersList.push(_react2.default.createElement(Grid, {
      key: 'AddMember',
      item: true
    }, _react2.default.createElement(_AddMember2.default, {
      ChatRoom: object
    })));

    if (objectId) {
      if (Members && Members.find(function (n) {
        return n.id === currentUserId;
      })) {
        if (createdById !== currentUserId) {
          membersList.push(_react2.default.createElement(Grid, {
            key: 'Exit',
            item: true
          }, _react2.default.createElement(_IconButton2.default, {
            title: "\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u044C \u0447\u0430\u0442",
            onClick: function () {
              var _ref6 = _asyncToGenerator(
              /*#__PURE__*/
              _regenerator2.default.mark(function _callee(event) {
                var _context2, leaveChatRoom, client;

                return _regenerator2.default.wrap(function _callee$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context2 = _this2.context, leaveChatRoom = _context2.query.leaveChatRoom, client = _context2.client;
                        _context3.next = 3;
                        return client.mutate({
                          mutation: (0, _graphqlTag2.default)(leaveChatRoom),
                          variables: {
                            where: {
                              id: objectId
                            }
                          }
                        }).then(function (r) {}).catch(console.error);

                      case 3:
                      case 'end':
                        return _context3.stop();
                    }
                  }
                }, _callee, _this2);
              }));

              return function (_x) {
                return _ref6.apply(this, arguments);
              };
            }()
          }, _react2.default.createElement(_ExitToApp2.default, null))));
        }
      } else {
        if (currentUserId) {
          var Invitation = Invitations && Invitations.find(function (n) {
            return n.User.id === currentUserId;
          }) || null;

          if (Invitation || isPublic) {
            membersList.push(_react2.default.createElement(Grid, {
              key: 'Join',
              item: true
            }, _react2.default.createElement(_IconButton2.default, {
              title: "\u0412\u0441\u0442\u0443\u043F\u0438\u0442\u044C \u0432 \u0447\u0430\u0442",
              onClick: function () {
                var _ref7 = _asyncToGenerator(
                /*#__PURE__*/
                _regenerator2.default.mark(function _callee2(event) {
                  var _context4, joinChatRoom, client;

                  return _regenerator2.default.wrap(function _callee2$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context4 = _this2.context, joinChatRoom = _context4.query.joinChatRoom, client = _context4.client;
                          _context5.next = 3;
                          return client.mutate({
                            mutation: (0, _graphqlTag2.default)(joinChatRoom),
                            variables: {
                              where: {
                                id: objectId
                              }
                            }
                          }).then(function (r) {}).catch(console.error);

                        case 3:
                        case 'end':
                          return _context5.stop();
                      }
                    }
                  }, _callee2, _this2);
                }));

                return function (_x2) {
                  return _ref7.apply(this, arguments);
                };
              }()
            }, _react2.default.createElement(_GroupAdd2.default, null))));
          }
        }
      }
    }

    return _react2.default.createElement(Grid, {
      container: true,
      spacing: 8,
      alignItems: 'center'
    }, _react2.default.createElement(Grid, {
      item: true,
      xs: true
    }, inEditMode ? this.getTextField({
      name: "name",
      label: "Название комнаты",
      helperText: "Название может быть произвольным"
    }) : _react2.default.createElement(_Typography2.default, {
      variant: 'title',
      align: 'left'
    }, this.getTitle())), canEdit ? _react2.default.createElement(Grid, {
      item: true
    }, inEditMode ? this.getTextField({
      name: "code",
      label: "Код",
      helperText: "Уникальный ключ комнаты"
    }) : code) : null, _react2.default.createElement(Grid, {
      item: true,
      className: classes.membersShortList
    }, membersList && membersList.length ? _react2.default.createElement(Grid, {
      container: true,
      alignItems: 'center',
      spacing: 8
    }, membersList) : null), _react2.default.createElement(Grid, {
      item: true
    }, this.getButtons()), _react2.default.createElement(Grid, {
      item: true
    }, publicButton));
  };

  ChatRoomView.prototype.renderDefaultView = function renderDefaultView() {
    var Grid = this.context.Grid;
    var classes = this.props.classes;
    var object = this.getObjectWithMutations();
    var canEdit = this.canEdit();
    var inEditMode = this.isInEditMode();
    var objectId = object.id,
        Members = object.Members,
        isPublic = object.isPublic; // let members;

    var messages = void 0;
    var editor = void 0;

    if (objectId) {
      // members = <MembersList
      //   object={object}
      // />
      messages = _react2.default.createElement(_Messages2.default // Room={object}
      , {
        where: {
          Room: {
            id: objectId
          }
        }
      });
      editor = _react2.default.createElement(_App.NewMessage, {
        cacheKey: 'newMessage_room_' + objectId,
        data: {
          Room: {
            connect: {
              id: objectId
            }
          }
        }
      });
    }

    return _react2.default.createElement('div', {
      className: classes.chat
    }, _react2.default.createElement('div', {
      className: classes.messages
    }, messages), _react2.default.createElement('div', {
      className: classes.editor
    }, editor));
  };

  ChatRoomView.prototype.renderEditableView = function renderEditableView() {
    return this.renderDefaultView();
  };

  ChatRoomView.prototype.render = function render() {
    var classes = this.props.classes;
    return _react2.default.createElement('div', {
      className: classes.root
    }, _EditableView.prototype.render.call(this));
  };

  return ChatRoomView;
}(_Editable2.default);

exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(ChatRoomView, props);
});